import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {BsModalService} from 'ngx-bootstrap/modal';
import {SERVER_API_URL} from 'src/app/app.constants';

import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';

import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {MyCertificateService} from 'src/app/client/my-certificate/my-certificate.service';
import {Principal} from 'src/app/core';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';


@Component({
  selector: 'jhi-scope-my-certificates',
  templateUrl: './scope-my-certificates.component.html',
  styleUrls: []
})
export class ScopeMyCertificatesComponent implements OnInit {

  certificates = [];
  currentAccount: any;

  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  searchText: string;
  flag: boolean;

  private resourceUrl = SERVER_API_URL + "api/";
  pid: any;
  sid: any;

  constructor(
    private modalService: BsModalService,
    private myCertificateService: MyCertificateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private parseLinks: JhiParseLinks,
    private jhiAlertService: JhiAlertService,
    public principal: Principal,
    private eventManager: JhiEventManager,
    private languageChangeService: LanguageChangeService,

  ) {
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.routeData = this.activatedRoute.data.subscribe(data => {
      this.page = data.pagingParams.page;
      this.previousPage = data.pagingParams.page;
      this.reverse = data.pagingParams.ascending;
      this.predicate = data.pagingParams.predicate;
    });
    this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
      if (paramMap.get('size')) {
        this.itemsPerPage = paramMap.get('size')
      }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
            }
    });
  }

  previousState() {
    // window.history.back();
    this.router.navigateByUrl("/scope-my-suffix/"+this.sid+"/view")
  }

  backOnPrevious(){
    if(this.isOts) {
      this.router.navigate(['scope-my-suffix/'+this.sid+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
    } else {
      this.router.navigateByUrl("/scope-my-suffix/"+this.sid+"/view");
    }
    
  }

  isOts: boolean = false;
  otsKeyword: string = '';
  randomOtsId=null;

  ngOnInit() {
    this.activatedRoute.params.subscribe(event => {
      this.pid = event.pid ? event.pid : null;
      this.sid = event.sid ? event.sid : null;
    });
    

    const CURRENT_URL: string = this.router.url;
        this.isOts = CURRENT_URL.includes('ots');
        if(this.isOts) {
            this.otsKeyword = 'ots';
        }

        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];

        if(this.randomOtsId!=null ) {
            this.isOts=true;
            this.otsKeyword = 'ots';
        }


    this.principal.setTitle("My Certificate");
    this.certificates = [];

    this.principal.identity().then(account => {
      this.currentAccount = account;
    });

    this.registerChangeInManualRequest();

    if (this.pid && this.sid) {
      this.loadAll();
    }
  }

  ngOnDestroy() {
    if (this.eventSubscriber) 
    this.eventManager.destroy(this.eventSubscriber);
  }

  // get all requests
  getAllRequests() {
    this.myCertificateService.query().subscribe(data => {
      this.certificates = data.body;
    });
  }

  trackId(index: number, item: any) {
    return item.id;
  }

  registerChangeInManualRequest() {
    this.eventSubscriber = this.eventManager.subscribe('MyScopeCertificateListModification', response => this.loadAll());
  }

  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  private paginateManualRequests(data: any[], headers: HttpHeaders) {
    this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.certificates = data;
  }

  loadAll() {
    this.myCertificateService
      .queryWithUrl('/policy/' + this.pid + '/scope/' + this.sid, {
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort()
      })
      .subscribe(
        (res: HttpResponse<any[]>) => this.paginateManualRequests(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.transition();
    }
  }

  transition() {
    if (this.searchText) {
      this.searchItems();
      this.flag = true;
    } else {
      this.router.navigate(['/scope-my-suffix/scope-my-certificates/' + this.pid + '/' + this.sid], {
        queryParams: {
          page: this.page,
          size: this.itemsPerPage,
          sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }
      });
      this.loadAll();
    }
  }

  clear() {
    this.page = 0;
    this.router.navigate([
      '/scope-my-certificates/' + this.pid + '/' + this.sid,
      {
        page: this.page,
        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
      }
    ]);
    this.loadAll();
  }

  private onError(errorMessage: string) {
    this.jhiAlertService.error(errorMessage, null, null);
  }

  searchItems() {
    if (this.searchText.trim()) {
      var pNo = 0;
       var size = this.itemsPerPage;
      if (this.flag == true) {
        pNo = this.page - 1;
        size = this.itemsPerPage;
        this.flag = false;
      }
      this.principal
        .searchQuery(this.searchText.trim(), 'certificates/policy/' + this.pid + '/scope/' + this.sid + '/search', {
          page: pNo,
          size: size,
          sort: this.sort()
        })
        .subscribe(
          (res: HttpResponse<any[]>) => this.paginateManualRequests(res.body, res.headers),
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    } else {
      this.loadAll();
    }
  }

  downloadExcels() {
    const _URL =
      this.resourceUrl +
      "download-certificate-excelsheet"
    this.myCertificateService.queryWithURL(_URL).subscribe(res => {
      console.log(res);
      let headersData = res.headers.get("content-type");
      let fileName = res.headers.get("file-name");
      var file = new Blob([res.body], { type: headersData });
      var fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      //  window.URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);
    });

    //   this.childModal.hide();

  }
  onChange(value) {
    this.page = 0;
    this.itemsPerPage = value
    this.loadAll();
  }

}
